import { apiClient } from './client';
import type { ProfileVisit, ProfileVisitStats, VisitSourceValue } from '@/types/profile-visit';
import { VisitSource } from '@/types/profile-visit';

export const profileVisitService = {
  async getProfileVisits(params?: {
    limit?: number;
    offset?: number;
    include_seen?: boolean;
  }): Promise<ProfileVisit[]> {
    const { data } = await apiClient.get<ProfileVisit[]>('/profile-visits', { params });
    return data;
  },

  async markAsSeen(visitIds: number[]): Promise<{ success: boolean; marked: number }> {
    const { data } = await apiClient.post<{ success: boolean; marked: number }>('/profile-visits/mark-seen', { visit_ids: visitIds });
    return data;
  },

  async simulateVisits(): Promise<ProfileVisit[]> {
    const { data } = await apiClient.post<ProfileVisit[]>('/profile-visits/simulate');
    return data;
  },

  async trackVisit(params: {
    visited_user_id: number;
    visit_duration?: number;
    visit_source?: VisitSourceValue;
  }): Promise<ProfileVisit> {
    const { data } = await apiClient.post<ProfileVisit>('/profile-visits/track', null, { params });
    return data;
  },

  async getStats(days?: number): Promise<ProfileVisitStats> {
    const params = days ? { days } : undefined;
    const { data } = await apiClient.get<ProfileVisitStats>('/profile-visits/stats', { params });
    return data;
  },

  async trackCharacterVisit(params: {
    character_id: number;
    visit_duration?: number;
    visit_source?: VisitSourceValue;
  }): Promise<ProfileVisit> {
    const { data } = await apiClient.post<ProfileVisit>('/profile-visits/track-character', null, { params });
    return data;
  },

  // Admin endpoints
  async getSettings(): Promise<any> {
    const { data } = await apiClient.get('/admin/profile-visits/settings');
    return data;
  },

  async updateSettings(settings: any): Promise<any> {
    const { data } = await apiClient.put('/admin/profile-visits/settings', settings);
    return data;
  },

  async adminSimulateVisits(userId?: number): Promise<any> {
    const params = userId ? { user_id: userId } : undefined;
    const { data } = await apiClient.post('/admin/profile-visits/simulate', null, { params });
    return data;
  },

  async getAdminStats(days = 7): Promise<any> {
    const { data } = await apiClient.get('/admin/profile-visits/stats', { params: { days } });
    return data;
  },

  async getRecentVisits(params?: {
    limit?: number;
    offset?: number;
    user_id?: number;
    character_id?: number;
  }): Promise<any[]> {
    const { data } = await apiClient.get('/admin/profile-visits/recent', { params });
    return data;
  },
};